import React from "react";

const Reported = () => {
  return (
    <>
      <div className="h-screen text-gray-600 gap-5 flex flex-col justify-center items-center pb-16 text-xl lg:text-3xl">
        There's no Reported data available right now.
      </div>
    </>
  );
};

export default Reported;
